import Image from 'next/image';
import Link from 'next/link';

import { getInternalLink } from '@/utils/url/utm';

import {
  MY_CAR_FORUM_HOME_LINK,
  MY_CAR_FORUM_IMAGE_HEIGHT,
  MY_CAR_FORUM_IMAGE_LINK,
  MY_CAR_FORUM_IMAGE_WIDTH,
  MY_CAR_FORUM_INDEX_LINK,
} from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const MyCarForum: Component = () => (
  <div className={styles.containerMyCarForum}>
    <div>
      <Link
        href={getInternalLink(MY_CAR_FORUM_INDEX_LINK, 'discussions')}
        target="_blank">
        <Image
          alt="my car forum image"
          className={styles.imageVehicleCover}
          height={MY_CAR_FORUM_IMAGE_HEIGHT}
          src={MY_CAR_FORUM_IMAGE_LINK}
          width={MY_CAR_FORUM_IMAGE_WIDTH} />
      </Link>
    </div>
    <div className={styles.textMyCarForum}>
      Above discussions are extracted from
      {' '}
      <Link
        className={styles.textLink}
        href={getInternalLink(MY_CAR_FORUM_HOME_LINK, 'discussions')}
        target="_blank">
        mycarforum.com
      </Link>
      <br />
      You may login to Mycarforum using
      your Sgcarmart username & password.
    </div>
  </div>
);
